import ContractFullDTO from 'features/contracts/dtos/ContractFullDTO';
import PageCard from 'features/shared/components/card/PageCard';
import InfoItem from 'features/shared/components/infoItem/InfoItem';
import { formatDate } from 'features/shared/helpers/Formatters';
import { getCommodityIcon } from 'features/shared/helpers/Icons';
import { getTerminationDate } from 'features/shared/helpers/dateHelper';
import React from 'react'
import { useTranslation } from 'react-i18next';

type Props = {
  contract: ContractFullDTO;
}

const FuelingContractBasicInfoCard = ({ contract }: Props) => {
  // translations
  const tLabels = useTranslation("contracts\\contracts").t;
  const tStatus = useTranslation("contracts\\enums\\contractStatus").t;
  const tTerms = useTranslation("shared\\terms").t;

  // sub-renders
  const renderSignatureDate = () => { 
    if (contract.signitureDate) {
      return (
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("contractBasicInfoCard.signitureDate")} value={formatDate(contract.signitureDate)} icon="file-signature" />
        </div>
      );
    }
  }

  const renderTerminationDate = () => { 
    if (contract.terminationDatePresentation) {
      return (
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("contractBasicInfoCard.terminationDate")} value={getTerminationDate(contract, tTerms)} icon="calendar-times" />
        </div>
      );
    }
  }

  // render
  return (
    <PageCard title={tLabels("contractBasicInfoCard.cardTitle")} bodyClassName="pb-0">
      <div className="row no-gutters">
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("contractBasicInfoCard.contractNumber")} value={contract.contractNumber!} icon={getCommodityIcon(contract.commodityDetail)} />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("contractBasicInfoCard.contractStatus")} value={tStatus(contract.contractStatus!)} icon="tag" />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("contractBasicInfoCard.product")} value={contract.product!} icon="shopping-cart"  />
        </div> 
        {renderSignatureDate()}
        {renderTerminationDate()}
      </div>
    </PageCard>
  )
}

export default FuelingContractBasicInfoCard;